export default {
  'unprocessedData': 'There are still unprocessed records',
  'pls_select': 'Please select',
  'pls_input': 'Please enter',
  'pls_input_name_pinyin': 'Please enter the name (pinyin)',
  'max': 'The application amount must not be greater than the account balance',
  'min': 'Application amount must not be less than 0',
  'correctAmount': 'Please enter the correct amount',
  'doSuccess': 'Operation successful',
  'doError': 'Update failed, please contact customer service',
  'otherAccount': {
  'getApplyRecordError': 'Error retrieving application records, please contact customer service',
  'applyTradeAccountTypeListError': 'An error occurred while retrieving the application account information, please contact customer service'
  }
}
